import IntroTutorial from './IntroTutorial';

export default IntroTutorial;


// WEBPACK FOOTER //
// /src/components/intro/pages/tutorial/index.js